module.exports = __webpack_public_path__ + "img/mind_template_item_2_7.ed62d3cb.png";